import { Tag } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { AnalysisCategory } from '../../types';

type Props = {
  category: Maybe<AnalysisCategory>;
};

export default function AnalysisCategory({ category }: Props) {
  const { t } = useTranslation();

  if (!category) return null;

  return (
    <span className="flex items-center gap-1 rounded border border-neutral-300 bg-neutral-100 px-2 py-0.5 text-xs text-neutral-500 dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-400">
      <Tag className="h-3 w-3" />

      {t(`CATEGORY_${category}`)}
    </span>
  );
}
